import { addUser, getUser, setStatusUser } from "./users.actions";
import { addUserService, getUserService } from "../../services/user.service";

export const getUserThunk = (email) => async (dispatch) => {
  dispatch(setStatusUser("loading"));
  try {
    const backendUser = await getUserService(email);
    console.log("datagetUser", backendUser);
    if (backendUser.id) {
      dispatch(getUser(backendUser));
    }
    // siempre retorno algo ({} o user), para el componente
    return backendUser;
  } catch (err) {
    console.error("Error en getUserThunk:", err);
    return {};
  } finally {
    dispatch(setStatusUser("loaded"));
  }
};

export const addUserThunk = (userObj) => async (dispatch) => {
  dispatch(setStatusUser("loading"));
  try {
    const newUser = await addUserService(userObj);
    console.log("newUser", newUser);
    if (newUser.id) {
      dispatch(addUser(newUser));
    }
    return newUser;
  } catch (err) {
    console.error("Error en addUserThunk:", err);
    return {};
  } finally {
    dispatch(setStatusUser("loaded"));
  }
};


// //THUNKS

// import axios from "axios";
// import {addUser, getUser, setStatusUser} from "./users.actions";
// import {addUserService, getUserService} from "../../services/user.service";

// export const getUserThunk = (id) => {
//     return async (dispatch) => {
//         try {
//             dispatch(setStatusUser('loading'));
//             console.log("IDUSER", id);
//             const data = await getUserService(id);
//             console.log("datagetUser", data);
//             if (!data.error) dispatch(getUser(data));
//         } catch (error) {
//             console.error(error);
//         }
//         dispatch(setStatusUser('loaded'));
//     };
// };


// export const addUserThunk = (obj) => {
//     return async (dispatch) => {
//         try {
//             dispatch(setStatusUser('loading'));
//             const { data } = await addUserService(obj);
//             console.log("data", data);
//             if (!data.error) dispatch(addUser(data));
//         } catch (error) {
//             console.error(error);
//         }
//         dispatch(setStatusUser('loaded'));
//     };
// };
